import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { changeMastersInitialStateProducts, handlePaginationStateProducts } from "../../../store/masters/mastersSlice";

const mapStateToProps = (state) => {
    return {
        // products
        formType: state.masters.formTypeProducts,
        initialValues: state.masters.initialValuesProducts,
        showDrawer: state.masters.showDrawerProducts,
        pagination: state.masters.paginationProducts,
    };
};

const mapDispatch = {
    changeProductsInitialState: changeMastersInitialStateProducts,
    handlePaginationState: handlePaginationStateProducts,
};

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(mapDispatch, dispatch);

const Store = (Container) =>
    connect(mapStateToProps, mapDispatchToProps)(Container);

export default Store; 